import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Autocomplete, ListItemText, Alert } from '@mui/material';
import * as React from 'react';
import Common from '../utilities/common';
import $ from "jquery";
import { TrameroSearchModel } from '../Tramero/TrameroSearchModel';
import { Apellido } from '../Apellidos/Apellido';

export interface IRepairNombreViaProps {
    open: boolean;
    id: number;
    nombreVia: string;
    onCancel?: any;
    onSave?: any;
}

export interface IRepairNombreViaState {
    tramero: any[];
    normalizacionItem: any;
    open: boolean;
    hasErrors: boolean;
}

export default class RepairNombreVia extends React.Component<IRepairNombreViaProps, IRepairNombreViaState> {
    _sexo: string = '';
    _id: number = -1;
    _tramero: any;
    _nombreVia: string = '';

    public constructor(props: IRepairNombreViaProps) {
        super(props);

        this.state = {
            tramero: [],
            open: false,
            normalizacionItem: null,
            hasErrors: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IRepairNombreViaProps>, nextContext: any): void {
        this._id = nextProps.id;
        this._nombreVia = nextProps.nombreVia;
        
        this.setState({
            open: nextProps.open
        });

        this.GetData();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    {
                        `Reparar nombre de vía`
                    }
                </DialogTitle>
                <DialogContent>
                    {
                        this.state.tramero.length > 0 && (
                            <Autocomplete
                                options={this.GetAutocompleteOptions()}
                                getOptionLabel={(option: any) => option.fullName!}
                                onChange={(event: any, newValue: any) => {
                                    this.SetSelectedValue(newValue.id);
                                }}
                                isOptionEqualToValue={(option: any, value: any) => option.fullName === value.fullName}
                                renderInput={(params) => (
                                    <TextField {...params} label="Registro" variant="standard"/>
                                )}
                                renderOption={(props, item) => (
                                    <li {...props} key={item.id}>
                                        <ListItemText>{item.fullName}</ListItemText>
                                    </li>
                                )}
                            />
                        )
                    }
                    {
                        this.state.tramero.length == 0 && (
                            <Alert severity='warning'>
                                No se ha encontrado información de la vía en el tramero
                            </Alert>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    {
                        this.state.tramero.length > 0 && (
                            <Button onClick={this.Save.bind(this)}>Ok</Button>
                        )
                    }
                    {
                        !this.state.hasErrors && (
                            <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                        )
                    }
                </DialogActions>
            </Dialog>
        )
    }

    private GetAutocompleteOptions() {
        const options: any[] = [];
        console.log('GetAutocompleteOptions', this.state.tramero);

        for(let i = 0; i < this.state.tramero.length; i++) {
            const direccion = this.state.tramero[i];
            const value = options.find((a) => {
                return a.fullName == `${direccion.tipoVia} - ${direccion.nombreVia} - ${direccion.municipio} - ${direccion.provincia} - ${direccion.comunidadAutonoma}`;
            });

            if(value == null) {
                options.push(
                    {
                        id: direccion.id,
                        fullName: `${direccion.tipoVia} - ${direccion.nombreVia} - ${direccion.municipio} - ${direccion.provincia} - ${direccion.comunidadAutonoma}`
                    }
                )
            }
        }

        return options;
    }

    private SetSelectedValue(id: number) {
        const value = this.state.tramero.find((a) => {
            return a.id == id
        });

        this._tramero = value;
        console.log('trameroSeleccionado', this._tramero);
    }

    private GetData() {
        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    normalizacionItem: response[0]
                }
            );

            this.SearchNombreVia(response[0]);
        });
    }

    private SearchNombreVia(normalizacionItem: any) {
        console.log('normalizacionItem', normalizacionItem);
        if(Common.IsNullOrEmpty(this._nombreVia)) {
            return;
        }

        let nombresVia = this._nombreVia.split(' ');
        let nombreVia: string = '';

        for (let i = 0; i < nombresVia.length; i++) {
            if(nombresVia[i].toLowerCase() != 'de' && nombresVia[i].toLowerCase() != 'del') {
                nombreVia = nombresVia[i];
                break;
            }
        }

        console.log('SearchNombreVia', nombreVia);

        let url = `${Common.END_POINT}/masters/tramero/search/via/${nombreVia}/${normalizacionItem.id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('tramero', response);
            this.setState(
                {
                    tramero: response
                }
            );
        });
    }

    private Save() {
        if(this.state.hasErrors) {
            this.Close();
            return;
        }
        const normalizacionItem = JSON.parse(JSON.stringify(this.state.normalizacionItem));
        normalizacionItem.nombreVia = this._tramero.nombreVia;
        normalizacionItem.tipoVia = this._tramero.tipoVia;

        if(normalizacionItem.fechaNacimiento.indexOf == undefined) {
            normalizacionItem.fechaNacimiento = '';
        }

        let url = `${Common.END_POINT}/normalizaciones/data/${this._id}/update/nombrevia`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(normalizacionItem),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: boolean) => {
            if(this.props.onSave != null) {
                this.props.onSave(response);
            }
        })
    }

    private Close() {
        if(this.props.onCancel != null) {
            this.props.onCancel();
        }
    }
}